import { createContext, useContext, useEffect, useState } from "react";
import React from 'react'
const SchedulerContext = createContext();


const SchedulerAppProvider = ({ children }) => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const [eventsData, setEventsData] = useState(JSON.parse(localStorage.getItem("eventsData")) || []);
    const [eventInput,setEventInput]=useState('');
    const [eventTitle, setEventTitle] = useState('')
    const [modalChildren,setModalChildren]=useState('');

    
    const addEventInput=(eventInput)=>{
        setEventsData([
            ...eventsData,
            eventInput
        ]); 
    }

    const updateEvent=(values)=>{
        const foundIndex = eventsData.findIndex(event => event.id == values.id);
        eventsData[foundIndex]=values;
        setModal(false);      
    }
    
    const deleteEvent=(eventId)=>{
       const newarr=eventsData.filter((event,index)=>{
        return event.id !== eventId
       })
       setEventsData(newarr);
       setModal(false)
       console.log("after Delete array" , newarr)
    }
   
    useEffect(()=>{
        console.log("eventsData-update and add",eventsData);
        localStorage.setItem("eventsData",JSON.stringify(eventsData))   
    },[addEventInput,updateEvent,deleteEvent])
   
   
    return (
        <SchedulerContext.Provider value={{
         eventsData,setEventsData,
         eventInput,setEventInput,
         eventTitle,setEventTitle,
         modal,setModal,
         toggle,
         modalChildren, setModalChildren,
         addEventInput,updateEvent,deleteEvent
        }}>
            {children}
        </SchedulerContext.Provider>
    )
}

const useSchedulerContext=()=>{
    return useContext(SchedulerContext)
}
export {SchedulerContext ,SchedulerAppProvider ,useSchedulerContext}